module.exports = __webpack_public_path__ + "static/img/List.b53a530a.png";